'use client';

import { useTranslations } from 'next-intl';

import Box from '@mui/material/Box';

import { BackToTop, ScrollProgress, useScrollProgress } from 'src/components/animate';

import HomeHero from '../home-hero';
import HomeWhatCan from '../home-what-can';
import HomeAdvertise from '../home-advertise';
import HomeKeepTrack from '../home-keep-track';

export function HomeView() {
  const pageProgress = useScrollProgress();
  const t = useTranslations('Common');

  return (
    <>
      <ScrollProgress
        variant="linear"
        progress={pageProgress.scrollYProgress}
        sx={{ position: 'fixed' }}
      />

      <BackToTop aria-label={t('backToTop')} />

      <Box component="main">
        <HomeHero />
        <HomeWhatCan />
        <HomeKeepTrack />
        <HomeAdvertise />
      </Box>
    </>
  );
}
